import * as reducers from '../reducers';
import { getEntities, MEMO_CATEGORIES } from '../reducers';
import { createSelector } from 'reselect';

export const getPopularCategories = createSelector(
  reducers.getStatisticsState,
  getEntities(MEMO_CATEGORIES),
  (stats, categories) => {
    if (!stats.memos.data || !stats.memos.data.categories) {
      return [];
    }
    return Object.getOwnPropertyNames(stats.memos.data.categories)
      .map(value => ({
        score: stats.memos.data.categories[value],
        ...categories[value]
      }))
      .filter(cat => cat.score > 0)
      .filter(cat => cat.name != undefined)
      .sort((a: any, b: any) => {
        if (a.score > b.score) return -1;
        if (a.score === b.score) return 0;
        return 1;
      });
  }
);

export const getActiveMembers = createSelector(
  reducers.statistics.getMembersStats,
  getEntities('staff'),
  (stats, staff) => {
    if (!stats || !stats.data) {
      return [];
    }
    return stats.data.map(stat => ({ ...stat, member: staff[stat.memberId] })).sort((a, b) => {
      if (a.memoCreated === undefined) {
        a.memoCreated = 0;
      }
      if (b.memoCreated === undefined) {
        b.memoCreated = 0;
      }
      if (a.memoCreated < b.memoCreated) {
        return 1;
      }
      if (a.memoCreated > b.memoCreated) {
        return -1;
      }
      return 0;
    });
  }
);

export const getActiveCustomers = createSelector(
  reducers.statistics.getCustomersStats,
  getEntities('customers'),
  (stats, customers) => {
    if (!stats || !stats.data) {
      return [];
    }
    return stats.data
      .map(stat => ({ ...stat, customer: customers[stat.customerId] }))
      .sort((a, b) => {
        if (a.memoCreated === undefined) {
          a.memoCreated = 0;
        }
        if (b.memoCreated === undefined) {
          b.memoCreated = 0;
        }
        if (a.memoCreated < b.memoCreated) {
          return 1;
        }
        if (a.memoCreated > b.memoCreated) {
          return -1;
        }
        return 0;
      });
  }
);
